// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuccessIconWrapper_wrapper__0ym8E","svg":"SuccessIconWrapper_svg__PHj0X"};